import { Component, Input } from '@angular/core';

@Component({
  selector: 'hello',
  template: `<h5 class="pl-3 pt-3 chat-header-txt">Hello {{name}}!</h5>`,
  styles: [`
 
  `]
})
export class HelloComponent  {
  @Input() name: string;
}
